var _defs, _path, _path2, _rect, _path3, _path4, _path5, _polyline, _polyline2, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ff1760c4-f1e7-44dc-a5fa-5fb349a32afe",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ac482a11-6311-4d3d-8433-0d3063d2e132,.e066aa02-3cc5-4d1d-9cc9-913f611b1058{fill:none;}.aadba211-4a30-40c4-8203-7b274f115f10,.ac482a11-6311-4d3d-8433-0d3063d2e132{stroke:#8e8e8e;}.aadba211-4a30-40c4-8203-7b274f115f10,.ac482a11-6311-4d3d-8433-0d3063d2e132,.e066aa02-3cc5-4d1d-9cc9-913f611b1058{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.aadba211-4a30-40c4-8203-7b274f115f10,.e67d67fd-153d-4052-aae7-5599bcffe341{fill:#3ba595;}.ee0c7778-9807-4092-b3ad-8ec212094ad2{fill:#fff;}.e066aa02-3cc5-4d1d-9cc9-913f611b1058{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bmp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ac482a11-6311-4d3d-8433-0d3063d2e132",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "aadba211-4a30-40c4-8203-7b274f115f10",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "e67d67fd-153d-4052-aae7-5599bcffe341",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ee0c7778-9807-4092-b3ad-8ec212094ad2",
    d: "M41.8,62.4a8.6,8.6,0,0,1,2.4-.2,4.3,4.3,0,0,1,2.8.7,2.2,2.2,0,0,1,.8,1.8,2.4,2.4,0,0,1-1.7,2.2h0a2.6,2.6,0,0,1,2.1,2.5,2.9,2.9,0,0,1-.8,2.1,5.4,5.4,0,0,1-3.5.9H41.8Zm1.3,4.1h1.2c1.4,0,2.2-.7,2.2-1.7s-.9-1.6-2.2-1.6H43.1Zm0,4.8h1.1c1.4,0,2.6-.5,2.6-2s-1.2-1.9-2.6-1.9H43.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ee0c7778-9807-4092-b3ad-8ec212094ad2",
    d: "M58.5,67.9c-.1-1.4-.2-3.1-.2-4.4h0L57,67.4l-1.8,4.9h-1l-1.6-4.8c-.5-1.5-.9-2.8-1.2-4h0c0,1.3-.1,3-.2,4.5l-.3,4.3H49.7l.7-10.1h1.7l1.7,4.9c.4,1.3.8,2.4,1,3.4h0l1.1-3.4,1.8-4.9h1.7L60,72.3H58.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ee0c7778-9807-4092-b3ad-8ec212094ad2",
    d: "M62,62.3h2.5a4.3,4.3,0,0,1,2.8.8,2.6,2.6,0,0,1,.9,2.1,3.2,3.2,0,0,1-.7,2.2,4.5,4.5,0,0,1-3.1,1.1H63.3v4H62Zm1.3,4.9h1.1c1.6,0,2.5-.7,2.5-2.1s-.9-2-2.4-2H63.3Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "e066aa02-3cc5-4d1d-9cc9-913f611b1058",
    points: "37.1 24.3 63.2 24.3 63.2 53.5 30.6 53.5 30.6 32.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "e066aa02-3cc5-4d1d-9cc9-913f611b1058",
    points: "31.1 53.5 42.7 41.9 53.9 53"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e066aa02-3cc5-4d1d-9cc9-913f611b1058",
    x1: 48,
    y1: 47.1,
    x2: 62.6,
    y2: 32.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "e066aa02-3cc5-4d1d-9cc9-913f611b1058",
    cx: 48,
    cy: 33.8,
    r: 3.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmp);
export default __webpack_public_path__ + "static/media/bmp.f005c029b850f2a875e7abd3ff1df6e9.svg";
export { ForwardRef as ReactComponent };